import {VscCommentDiscussion, VscFiles} from "react-icons/vsc";
import {formatNumber} from "../../../utils/Functions";
import React from "react";
import useScalewayRateLimitsCard from "../../../hooks/dashboard/useScalewayRatelimitsCard";

export default function ScalewayRatelimitsCard() {
    const {requestPerMinutes, tokensPerMinutes} = useScalewayRateLimitsCard();

    return <div
        className='rounded-xl w-auto border p-8 shadow bg-white text-black text-base flex flex-col justify-between min-h-64'>
        <div className="pb-6">
            <div className='font-bold'>Limites d'envoi Scaleway</div>
        </div>
        <div className='space-y-4 grow flex flex-col justify-center gap-2'>
            <div className='flex flex-col gap-5 w-full justify-center items-center'>
                <div className='flex w-full justify-center gap-5'>
                    <div className='flex'>
                        <VscCommentDiscussion className='w-12 h-12 text-black' />
                        <div className='text-4xl font-extrabold text-perso-lightBlue'>
                            {isNaN(tokensPerMinutes[1]) ?
                                "?" : formatNumber(tokensPerMinutes[1])}
                        </div>
                    </div>
                    <div className='flex '>
                        <VscFiles className='w-12 h-12 text-black' />
                        <div className='text-4xl font-extrabold text-perso-lightBlue'>
                            {isNaN(tokensPerMinutes[0]) ?
                                "?" : `${formatNumber(tokensPerMinutes[0])}`
                            }
                        </div>
                    </div>
                </div>
                <div className='opacity-25 font-bold text-black text-sm'>Tokens par minutes</div>
            </div>
            <div className='flex flex-col gap-5 w-full justify-center items-center'>
                <div className='flex w-full justify-center gap-5'>
                    <div className='flex'>

                        <VscCommentDiscussion className='w-12 h-12 text-black' />
                        <div className='text-4xl font-extrabold text-perso-lightBlue'>
                            {isNaN(requestPerMinutes[1]) ?
                                "?" : formatNumber(requestPerMinutes[1])}
                        </div>
                    </div>
                    <div className='flex'>
                        <VscFiles className='w-12 h-12 text-black' />
                        <div className='text-4xl font-extrabold text-perso-lightBlue'>
                            {isNaN(requestPerMinutes[0]) ?
                                "?" : `${formatNumber(requestPerMinutes[0])}`
                            }
                        </div>
                    </div>

                </div>
                <div className='opacity-25 font-bold text-black text-sm'>Requêtes par minutes</div>
            </div>
        </div>
    </div>
}